import { motion } from "framer-motion";

export const LOGO = "/assets/logo-full.png";
export const MARK = "/assets/logo-mark.png";
export const FLEET_IMG = "/assets/fleet-wide.png";
export const EASE = [0.22, 1, 0.36, 1];

export const gbp = (n) =>
  "£" +
  Number(n).toLocaleString("en-GB", {
    minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2,
    maximumFractionDigits: 2,
  });

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 34, filter: "blur(5px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedHeading = ({ children, delay = 0 }) => (
  <motion.span
    className="block overflow-hidden"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
  >
    <motion.span
      className="block pb-2"
      variants={{ hidden: { y: "112%" }, show: { y: 0 } }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const DemoTag = ({ children = "Demo" }) => (
  <span className="demo-tag" data-testid="demo-tag">{children}</span>
);
